module.exports = function(service) {
	service 
  .factory("deleteDataService", deleteDataService);
  deleteDataService.$inject = ['$resource','API_URL'];
  function deleteDataService($resource, API_URL) {
   var data = $resource(API_URL+ ":param1/:param2/:param3", {param1:"@param1", param2:'@param2',param3:'@param3'} ,{
      state: "open"
    }, {
      remove: {
        method: "DELETE"
      }
    });
   return data;
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/deleteDataService.js
// module id = 595
// module chunks = 0